<template>
  <b-card-body
    v-if="data"
    class="statistics-body"
  >
    <b-row>
      <b-col
        v-for="(item,key) in data"
        :key="key"
        xl="3"
        md="6"
        :class="item.customClass"
      >
        <b-media no-body>
          <b-media-aside

            class="mr-2"
          >
            <b-avatar
              size="48"
              :variant="item.color"
            >
              <feather-icon
                size="24"
                :icon="item.icon"
              />
            </b-avatar>
          </b-media-aside>
          <b-media-body class="my-auto">
            <h5
              class="font-weight-bolder mb-0"
              style="direction: ltr"
            >
              {{ item.title }}
            </h5>
            <b-card-text class="font-small-3 mb-0">
              {{ item.subtitle }}
            </b-card-text>
          </b-media-body>
        </b-media>
      </b-col>
    </b-row>
  </b-card-body>
</template>

<script>
import {
  BCardText, BCardBody, BRow, BCol, BMedia, BMediaAside, BAvatar, BMediaBody,
} from 'bootstrap-vue'

export default {
  components: {
    BRow,
    BCol,
    BCardText,
    BCardBody,
    BMedia,
    BAvatar,
    BMediaAside,
    BMediaBody,
  },
  props: {
    service: {
      type: Object,
      default: () => '',
    },
    data: {
      type: Array,
      default: () => [],
    },
  },
}
</script>
